// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8e7e666c","453":"cbc88d84","744":"6c4555f7","801":"60064b1a"}[chunkId] + ".chunk.js";
};